import {
    Button,
    ButtonGroup,
    Input,
} from "reactstrap";
import { useEffect, useMemo, useState } from "react";
import { MigrationType } from "../../type";
import excel from "../../../../assets/images/excel.svg";
import PageLayout from "../../../layout/page";
import {
    desktopIcon,
    searchIcon,
} from "../../../../constant/icons";
import { useApp } from "../../../../components/app";

const FunctionSelection = ({
    selectedFunctions,
    setSelectedFunctions,
    onValidate,
}: any) => {
    const app = useApp();
    const [migrationType, setMigrationType] = useState<MigrationType>("Full");

    // Handle setting selection based on migration type
    useEffect(() => {
        const functionList = app.currentApp?.functionList || [];

        if (migrationType === "Full") {
            const allFunctions = functionList.map((item: any) => item.id);
            setSelectedFunctions(allFunctions);
            if (onValidate) onValidate(() => true);
        } else if (migrationType === "Basic") {
            const basicFunctions = functionList
                .filter((x: any) => JSON.parse(x.setting)?.isBasicMigration)
                .map((item: any) => item.id);
            setSelectedFunctions(basicFunctions);
            if (onValidate) onValidate(() => basicFunctions.length > 0);
        } else {
            // Customization
            setSelectedFunctions([]);
            if (onValidate) onValidate(() => false);
        }
    }, [migrationType, app.currentApp?.functionList]);

    // Handler for checkbox toggle
    const handleCheckboxChange = (checked: boolean, id: number) => {
        let updatedSelection: number[];

        if (checked) {
            updatedSelection = [...selectedFunctions, id];
        } else {
            updatedSelection = selectedFunctions.filter((x: number) => x !== id);
        }

        setSelectedFunctions(updatedSelection);

        // Only validate when in Customization mode
        if (migrationType === "Customization" && onValidate) {
            onValidate(() => updatedSelection.length > 0);
        }
    };

    // Generate function list UI
    const functionList = useMemo(() => {
        const list = app.currentApp?.functionList || [];

        return list
            .filter((x: any) => {
                if (migrationType !== "Basic") return true;
                return JSON.parse(x.setting)?.isBasicMigration;
            })
            .map((item: any, index: number) => (
                <li key={`${migrationType}-${index}`}>
                    <Input
                        type="checkbox"
                        id={`checkBox${index}`}
                        onChange={(e) => handleCheckboxChange(e.target.checked, item.id)}
                        checked={
                            migrationType !== "Customization"
                                ? true
                                : selectedFunctions.includes(item.id)
                        }
                        disabled={migrationType !== "Customization"}
                    />
                    <label htmlFor={`checkBox${index}`}>
                        <div>
                            <span>{desktopIcon.icon}</span>
                            <h6>{item.functionName}</h6>
                        </div>
                        <div>
                            <span>One</span>
                            <h6>{item.functionCode}</h6>
                        </div>
                        {item.functionColumns?.length > 0 && (
                            <div className="xlfile">
                                <img src={excel} alt="excel" />
                                Excel File
                            </div>
                        )}
                    </label>
                </li>
            ));
    }, [migrationType, selectedFunctions, app.currentApp?.functionList]);

    return (
        <PageLayout
            title={<></>}
            View={
                <>
                    <div className="function-migrate-head">
                        <ButtonGroup>
                            <Button
                                color="primary"
                                outline
                                active={migrationType === "Full"}
                                onClick={() => setMigrationType("Full")}
                            >
                                Full Migration
                            </Button>
                            <Button
                                color="primary"
                                outline
                                active={migrationType === "Basic"}
                                onClick={() => setMigrationType("Basic")}
                            >
                                Basic Migration
                            </Button>
                            <Button
                                color="primary"
                                outline
                                active={migrationType === "Customization"}
                                onClick={() => setMigrationType("Customization")}
                            >
                                Customization Migration
                            </Button>
                        </ButtonGroup>
                        <div className="search_box">
                            <Button color="link" className="p-0">
                                {searchIcon.icon}
                            </Button>
                            <input
                                name="searchbox"
                                placeholder="Search.."
                                type="search"
                                className="top-element"
                            />
                        </div>
                    </div>
                    <ul className="migration-card-list">{functionList}</ul>
                </>
            }
        />
    );
};

export { FunctionSelection };
